import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postMultipleMessageFailure,
  postMultipleMessageSuccess,
} from "../slices/features/postMultipleMessage";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postMultipleMessageSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.postMultipleMessage,
      baseUrl,
      id,
      data
    );

    yield put(postMultipleMessageSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    // A bulk send can outlive the request timeout while the server keeps sending
    // Treat a timeout or lost connection as still-in-progress, not a failure
    const isStillSending = error?.data?.message === "offline";

    if (isStillSending && payload?.cbTimeout) {
      payload.cbTimeout();
    } else {
      const message = error?.statusText || error?.data?.errors?.message;
      payload?.cbFailure && payload?.cbFailure(message);
    }

    yield put(postMultipleMessageFailure({ statusCode, statusText }));
  }
}

export function* watchPostMultipleMessage() {
  yield takeLatest(RequestTypes.POST_MULTIPLE_MESSAGE_REQUEST, postMultipleMessageSaga);
}